/**
 * 学习乐园 · 堵车棋 Rush Hour（game-rushhour.js）
 * ============================================================
 * 「逻辑与推理」组新作：6×6 停车场，红色小车被车流堵住，挪开车把它从
 * 右侧出口开出去。三档：入门（默认档，3-4 车）、进阶（5-6 车）、挑战
 * （7-8 车）。每关最少步数由 BFS 现算，只发可解关卡。计步与经典桌游
 * 一致：一辆车滑动任意格数算 1 步。查一查从当前局面 BFS 现算「离出口
 * 最少还要几步 + 下一步挪哪辆车」，是真实搜索。走进死局讲成因，撤销
 * 随时可用；不即时判错；不计时；成绩按档记完成局数与最少步数，存本机。
 *
 * 冒烟钩子：window.STRush 暴露 slideRange / allMoves / applyMove /
 * solveBFS / bestMove / stepCount 与 state()。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-rushhour';
  var RECORD_KEY = 'study-rushhour-record';
  var N = 6;

  /* 车格式 [id, horiz(1横0竖), fixed(横车=row/竖车=col), pos(最小变动坐标), len]。
     id 0 恒为红色主车：横放、fixed=2（出口行），开到 pos=4（右端触出口）即赢。 */
  var LEVELS = [
    { mode: 'easy', name: '入门', hint: '3-4 车 · 默认档', levels: [
      [[0, 1, 2, 1, 2], [1, 0, 3, 1, 2], [2, 0, 4, 2, 2]],
      [[0, 1, 2, 0, 2], [1, 0, 3, 1, 2], [2, 0, 4, 2, 2], [3, 0, 5, 1, 2]]
    ] },
    { mode: 'mid', name: '进阶', hint: '5-6 车', levels: [
      [[0, 1, 2, 1, 2], [1, 0, 4, 2, 2], [2, 0, 5, 2, 2], [3, 1, 3, 3, 3], [4, 0, 3, 4, 2]],
      [[0, 1, 2, 0, 2], [1, 0, 3, 1, 2], [2, 0, 4, 2, 2], [3, 0, 5, 1, 2], [4, 1, 1, 4, 2], [5, 1, 4, 0, 3]]
    ] },
    { mode: 'hard', name: '挑战', hint: '8-9 车大堵局', levels: [
      [[0, 1, 2, 1, 2], [1, 0, 1, 0, 2], [2, 0, 3, 1, 2], [3, 0, 4, 1, 2], [4, 0, 5, 1, 2], [5, 1, 0, 2, 2], [6, 1, 3, 3, 2], [7, 1, 4, 1, 3]],
      [[0, 1, 2, 1, 2], [1, 0, 1, 0, 2], [2, 0, 3, 1, 2], [3, 0, 4, 2, 2], [4, 0, 5, 1, 2], [5, 1, 0, 4, 2], [6, 1, 3, 3, 3], [7, 1, 4, 1, 3], [8, 0, 3, 4, 2]]
    ] }
  ];

  var CARS = [];          // 当前关的车辆元数据（{id,horiz,fixed,len}，pos 在 state 里）
  var curLevels = [];     // 当前档的关卡组

  /* ============ 引擎：纯函数（cells 行列从 0 计） ============ */

  function cellsFor(st, cars) {
    var g = [];
    for (var r = 0; r < N; r++) g.push(new Array(N).fill(-1));
    for (var v = 0; v < cars.length; v++) {
      var c = cars[v];
      for (var k = 0; k < c.len; k++) {
        g[c.horiz ? c.fixed : st[v] + k][c.horiz ? st[v] + k : c.fixed] = v;
      }
    }
    return g;
  }

  // 车 vid 在自身方向可滑到的最小/最大 pos（含当前位置，路径逐格判空）
  function slideRangeFor(st, cars, vid) {
    var c = cars[vid], g = cellsFor(st, cars);
    var min = st[vid], max = st[vid];
    while (min - 1 >= 0 && g[c.horiz ? c.fixed : min - 1][c.horiz ? min - 1 : c.fixed] === -1) min--;
    while (max + c.len < N && g[c.horiz ? c.fixed : max + c.len][c.horiz ? max + c.len : c.fixed] === -1) max++;
    return { min: min, max: max };
  }

  // 全部着法：每辆车滑到自身方向上每个可停位（一次多格算 1 步）
  function allMovesFor(st, cars) {
    var out = [];
    for (var v = 0; v < cars.length; v++) {
      var rg = slideRangeFor(st, cars, v);
      for (var p = rg.min; p <= rg.max; p++) {
        if (p !== st[v]) out.push({ v: v, to: p });
      }
    }
    return out;
  }

  function applyMoveFor(st, cars, mv) {
    var nxt = st.slice();
    nxt[mv.v] = mv.to;
    return nxt;
  }

  function keyOf(st) { return st.join(','); }

  function isWinFor(st, cars) { return st[0] === N - cars[0].len; }

  // BFS 最少步数（滑动计步）。返回 {steps, firstMove} 或 null（死局）。
  function solveFor(st, cars) {
    var start = keyOf(st);
    if (isWinFor(st, cars)) return { steps: 0, firstMove: null };
    var seen = {}; seen[start] = 0;
    var prev = {};
    var q = [st.slice()]; var qi = 0;
    while (qi < q.length) {
      var cur = q[qi++], ck = keyOf(cur), d = seen[ck];
      var mvs = allMovesFor(cur, cars);
      for (var i = 0; i < mvs.length; i++) {
        var nxt = applyMoveFor(cur, cars, mvs[i]);
        var nk = keyOf(nxt);
        if (seen[nk] !== undefined) continue;
        seen[nk] = d + 1;
        prev[nk] = { from: ck, mv: mvs[i] };
        if (isWinFor(nxt, cars)) {
          var step = nk, first = null;
          while (prev[step].from !== start) step = prev[step].from;
          first = prev[step].mv;
          return { steps: seen[nk], firstMove: first };
        }
        q.push(nxt);
      }
    }
    return null;
  }

  /* 当前关包装（CARS 已就位后用） */
  function cellsOf(st) { return cellsFor(st, CARS); }
  function slideRange(st, vid) { return slideRangeFor(st, CARS, vid); }
  function allMoves(st) { return allMovesFor(st, CARS); }
  function applyMove(st, mv) { return applyMoveFor(st, CARS, mv); }
  function isWin(st) { return isWinFor(st, CARS); }
  function solve(st) { return solveFor(st, CARS); }
  function bestMove(st) { var s = solve(st); return s ? s.firstMove : null; }
  function stepCount(st) { var s = solve(st); return s ? s.steps : -1; }

  function carName(v) {
    if (v === 0) return '红色小车';
    var c = CARS[v];
    return (c.horiz ? '横' : '竖') + '车 ' + String.fromCharCode(64 + v + 1);
  }
  function dirName(v, from, to) {
    var c = CARS[v];
    if (c.horiz) return to > from ? '向右' : '向左';
    return to > from ? '向下' : '向上';
  }

  /* ============ 界面与交互 ============ */

  var root = null, ui = {};
  var S = {
    mode: 'easy', levelIdx: 0, cars: [], pos: [], sel: -1,
    steps: 0, hist: [], ended: false, soundOn: true, resetArm: false, resetTimer: null
  };

  function el(tag, cls, text) {
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    if (text !== undefined) d.textContent = text;
    return d;
  }

  function fmtSteps(n) { return n + ' 步'; }

  function newGame(levelIdx) {
    S.mode = LEVELS[levelIdx].mode;
    curLevels = LEVELS[levelIdx].levels;
    S.levelIdx = Math.floor(Math.random() * curLevels.length);
    var spec = curLevels[S.levelIdx];
    CARS = spec.map(function (row) {
      return { id: row[0], horiz: row[1] === 1, fixed: row[2], len: row[4] };
    });
    S.pos = spec.map(function (row) { return row[3]; });
    // 出题底线：BFS 验证可解才发；万一撞上不可解布局，换该档另一关
    if (!solveFor(S.pos, CARS)) {
      for (var i = 0; i < curLevels.length; i++) {
        if (i === S.levelIdx) continue;
        var cars2 = curLevels[i].map(function (r) { return { id: r[0], horiz: r[1] === 1, fixed: r[2], len: r[4] }; });
        var pos2 = curLevels[i].map(function (r) { return r[3]; });
        if (solveFor(pos2, cars2)) {
          S.levelIdx = i; CARS = cars2; S.pos = pos2; break;
        }
      }
    }
    S.sel = -1; S.steps = 0; S.hist = []; S.ended = false; S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    S.par = solveFor(S.pos, CARS).steps;   // 开局最少步数（出题底线：可解才发）
    renderLevels();
    syncLevels();
    buildBoard();
    renderBoard();
    renderStatus();
    renderRecord();
    renderNote('把红色小车从右边出口开出去：先点一辆车选中，再点它要滑到的空格——一次滑多格也算 1 步。', '');
    save();
  }

  function renderLevels() {
    var box = ui.levels;
    box.textContent = '';
    for (var i = 0; i < LEVELS.length; i++) {
      (function (lv, di) {
        var b = el('button', 'st-llk-pack-btn');
        b.type = 'button';
        b.setAttribute('data-level', String(i));
        b.setAttribute('role', 'radio');
        b.appendChild(el('span', 'st-llk-pack-name', lv.name));
        b.appendChild(el('small', 'st-llk-pack-hint', lv.hint));
        b.addEventListener('click', function () {
          if (S.mode === lv.mode) return;
          newGame(di);
        });
        box.appendChild(b);
      })(LEVELS[i], i);
    }
  }

  function syncLevels() {
    var btns = ui.levels.querySelectorAll('[data-level]');
    for (var i = 0; i < btns.length; i++) {
      var on = Number(btns[i].getAttribute('data-level')) === LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode);
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function buildBoard() {
    var board = ui.board;
    board.textContent = '';
    board.setAttribute('data-st-rh-n', String(N));
    for (var r = 0; r < N; r++) {
      for (var c = 0; c < N; c++) {
        (function (rr, cc) {
          var d = el('div', 'st-rh-cell');
          d.setAttribute('data-row', String(rr));
          d.setAttribute('data-col', String(cc));
          if (rr === 2 && cc === N - 1) d.classList.add('is-exit');
          board.appendChild(d);
        })(r, c);
      }
    }
    var exit = el('span', 'st-rh-exit-label', '出口 →');
    exit.setAttribute('data-st-rh-exit', '');
    board.appendChild(exit);
  }

  function renderBoard() {
    var board = ui.board;
    // 清掉旧车节点
    var olds = board.querySelectorAll('.st-rh-car');
    for (var i = 0; i < olds.length; i++) olds[i].remove();
    var g = cellsOf(S.pos);
    for (var v = 0; v < CARS.length; v++) {
      (function (vid) {
        var c = CARS[vid];
        var b = el('button', 'st-rh-car st-rh-c' + (vid % 6) + (vid === 0 ? ' is-red' : ''));
        b.type = 'button';
        b.setAttribute('data-car', String(vid));
        b.setAttribute('data-len', String(c.len));
        if (c.horiz) {
          b.classList.add('is-h');
          b.style.left = (S.pos[vid] * 100 / N) + '%';
          b.style.top = (c.fixed * 100 / N) + '%';
          b.style.width = (c.len * 100 / N) + '%';
          b.style.height = (100 / N) + '%';
        } else {
          b.classList.add('is-v');
          b.style.left = (c.fixed * 100 / N) + '%';
          b.style.top = (S.pos[vid] * 100 / N) + '%';
          b.style.width = (100 / N) + '%';
          b.style.height = (c.len * 100 / N) + '%';
        }
        b.setAttribute('aria-label', carName(vid) + '，长 ' + c.len + ' 格');
        b.addEventListener('click', function () { onCar(vid); });
        board.appendChild(b);
      })(v);
    }
    // 高亮：选中车 + 它的可滑范围空格
    var cells = board.querySelectorAll('.st-rh-cell');
    for (var k = 0; k < cells.length; k++) {
      cells[k].classList.remove('is-can', 'is-sel');
      var rr = Number(cells[k].getAttribute('data-row')), cc = Number(cells[k].getAttribute('data-col'));
      if (g[rr][cc] === S.sel) cells[k].classList.add('is-sel');
    }
    if (S.sel >= 0) {
      var rg = slideRange(S.pos, S.sel), c2 = CARS[S.sel];
      for (var p = rg.min; p <= rg.max; p++) {
        if (p === S.pos[S.sel]) continue;
        var cell = board.querySelector('.st-rh-cell[data-row="' + (c2.horiz ? c2.fixed : p) + '"][data-col="' + (c2.horiz ? p : c2.fixed) + '"]');
        if (cell) cell.classList.add('is-can');
      }
    }
  }

  function renderStatus() {
    if (S.ended) return;
    var lvName = '';
    for (var k = 0; k < LEVELS.length; k++) { if (LEVELS[k].mode === S.mode) lvName = LEVELS[k].name; }
    var sc = stepCount(S.pos);
    ui.status.className = 'st-status';
    ui.status.textContent = lvName + ' · 已走 ' + S.steps + ' 步'
      + (sc >= 0 ? ' · 从这里开出最少还要 ' + fmtSteps(sc) : '');
  }

  function renderNote(text, tone) {
    ui.note.textContent = text || '';
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    for (var i = 0; i < LEVELS.length; i++) {
      var r = rec['x' + i];
      var val = r && r.wins ? (r.wins + ' 局 · 最少 ' + r.best + ' 步') : '还没开出去过';
      var d = el('div', 'st-llk-stat');
      d.appendChild(el('span', 'st-llk-stat-label', LEVELS[i].name + '完成'));
      d.appendChild(el('strong', 'st-llk-stat-value', val));
      box.appendChild(d);
    }
  }

  function onCar(vid) {
    if (S.ended) return;
    S.sel = vid;
    sfx('sel');
    renderBoard();
    var rg = slideRange(S.pos, vid);
    var span = rg.max - rg.min;
    renderNote('选中了' + carName(vid) + '——它只能' + (CARS[vid].horiz ? '左右' : '上下') + '滑，现在能滑 ' + span + ' 格：点亮起的空格滑过去' + (span === 0 ? '（现在两头都被堵住，先挪开别的车）' : '。'), '');
  }

  // 点空格：若在选中车的滑行线上且路径通，滑动过去
  function onCell(rr, cc) {
    if (S.ended) return;
    if (S.sel < 0) {
      renderNote('先点一辆车选中它，再点它要滑到的空格。红色小车要往右边出口开。', '');
      return;
    }
    var c = CARS[S.sel];
    var lineOk = c.horiz ? (rr === c.fixed) : (cc === c.fixed);
    if (!lineOk) {
      sfx('bad');
      renderNote(carName(S.sel) + '只能沿' + (c.horiz ? '横向（左右）' : '纵向（上下）') + '滑——你要点的格子不在它的行' + (c.horiz ? '' : '/列') + '上。换它行上的空格，或先点别的车。', 'bad');
      return;
    }
    var to = c.horiz ? cc : rr;
    if (to === S.pos[S.sel]) return;
    var rg = slideRange(S.pos, S.sel);
    if (to < rg.min || to > rg.max) {
      sfx('bad');
      renderNote('滑不过去——中间有车挡着。它现在最远能滑到 ' + (rg.min === S.pos[S.sel] ? '原地' : '另一头 ' + rg.min) + ' 到 ' + (rg.max === S.pos[S.sel] ? '原地' : rg.max) + ' 的范围，看点亮起的格子。', 'bad');
      return;
    }
    S.hist.push({ pos: S.pos.slice(), steps: S.steps });
    S.pos[S.sel] = to;
    S.steps++;
    S.sel = -1;
    sfx('ok');
    if (isWin(S.pos)) {
      renderBoard();
      winGame();
      return;
    }
    renderBoard();
    renderStatus();
    if (stepCount(S.pos) < 0) {
      sfx('bad');
      renderNote('卡住了：挪完这步，剩下的车怎么滑都开不出红色小车（搜索验证过）。点「撤销一步」退回去——查一查可以看哪步离出口更近。', 'bad');
      return;
    }
    renderNote('滑过去了，已走 ' + S.steps + ' 步。离出口最少还要 ' + fmtSteps(stepCount(S.pos)) + '。', '');
  }

  function undo() {
    if (S.ended || !S.hist.length) {
      renderNote('还没走过，没法撤销。', '');
      return;
    }
    var back = S.hist.pop();
    S.pos = back.pos; S.steps = back.steps; S.sel = -1;
    if (S.ended) { S.ended = false; }
    sfx('sel');
    renderBoard();
    renderStatus();
    renderNote('退回上一步。换一辆车挪挪看。', '');
  }

  function checkBoard() {
    if (S.ended) return;
    var s = solve(S.pos);
    if (!s) {
      renderNote('从当前局面搜索过：已经无法把红色小车开出去了。点「撤销一步」退回去换一步。', 'bad');
      return;
    }
    if (s.steps === 0) { renderNote('红色小车已经顶着出口了！', 'ok'); return; }
    var mv = s.firstMove;
    renderNote('下一步：把' + carName(mv.v) + dirName(mv.v, S.pos[mv.v], mv.to) + '滑到 ' + (mv.to + 1) + ' 号位'
      + '——走完这步，离出口最少还要 ' + fmtSteps(s.steps - 1) + '（盘上已亮起）。', 'ok');
    S.sel = mv.v;
    markHint(mv);
    renderBoard();
    S.sel = -1;
  }

  function markHint(mv) {
    var board = ui.board;
    var c = CARS[mv.v];
    var cells = board.querySelectorAll('.st-rh-cell');
    for (var k = 0; k < cells.length; k++) cells[k].classList.remove('is-hint');
    for (var p = Math.min(S.pos[mv.v], mv.to); p <= Math.max(S.pos[mv.v], mv.to); p++) {
      var cell = board.querySelector('.st-rh-cell[data-row="' + (c.horiz ? c.fixed : p) + '"][data-col="' + (c.horiz ? p : c.fixed) + '"]');
      if (cell) cell.classList.add('is-hint');
    }
  }

  function winGame() {
    S.ended = true;
    sfx('win');
    var sc = S.par;
    var rec = loadRecord();
    var key = 'x' + LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode);
    var cur = rec[key];
    if (!cur || typeof cur !== 'object' || Array.isArray(cur)) cur = { wins: 0, best: 0 };
    cur.wins++;
    if (!cur.best || S.steps < cur.best) cur.best = S.steps;
    rec[key] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 静默 */ }
    renderRecord();
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '开出去了！用了 ' + S.steps + ' 步（这一关最少 ' + fmtSteps(sc >= 0 ? sc : S.steps) + '）——点「新开一局」再来。';
    renderNote('错车让路的本质是「谁给谁腾位置」：每辆挡路车自己也被堵着，先解决它的堵点。你刚才就是这么一层层解开的。', 'ok');
    renderButtons();
    save();
  }

  function renderButtons() { /* 预留：结束时按钮态 */ }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderNote('再点一次「重置成绩」确认清空；点别的按钮取消。', 'bad');
      S.resetTimer = setTimeout(function () { S.resetArm = false; }, 4000);
      return;
    }
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    S.resetArm = false;
    try { localStorage.removeItem(RECORD_KEY); } catch (e) { /* 静默 */ }
    renderRecord();
    renderNote('成绩已清空。', '');
  }

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return (r && typeof r === 'object' && !Array.isArray(r)) ? r : {};
    } catch (e) { return {}; }
  }

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime, seq;
      if (kind === 'ok') seq = [[523, 0], [659, 0.07]];
      else if (kind === 'win') seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[330, 0]];
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator(), g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g); g.connect(actx.destination);
        o.start(t + seq[i][1]); o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  function save() {
    try {
      localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, mode: S.mode, soundOn: S.soundOn }));
    } catch (e) { /* 存储不可用静默 */ }
  }

  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (!d || d.v !== 1) return;
      if (d.mode === 'easy' || d.mode === 'mid' || d.mode === 'hard') S.mode = d.mode;
      S.soundOn = d.soundOn !== false;
    } catch (e) { /* 忽略脏数据 */ }
  }

  function bindSoundPicker() {
    var btns = document.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          var all = document.querySelectorAll('[data-st-sound]');
          for (var j = 0; j < all.length; j++) {
            var on = all[j].getAttribute('data-st-sound') === 'on' === S.soundOn;
            all[j].classList.toggle('is-active', on);
            all[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
          if (S.soundOn) sfx('sel');
        });
      })(btns[i]);
    }
  }

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.board = root.querySelector('[data-st-rh-board]');
    ui.levels = root.querySelector('[data-st-rh-levels]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.record = root.querySelector('[data-st-record]');
    ui.saved = root.querySelector('[data-st-saved]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.undoBtn = root.querySelector('[data-st-rh-undo]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.resetBtn = root.querySelector('[data-st-reset]');
    if (!ui.board || !ui.levels) return;

    restorePrefs();
    renderLevels();
    bindSoundPicker();

    ui.newBtn.addEventListener('click', function () { newGame(LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode)); });
    ui.checkBtn.addEventListener('click', checkBoard);
    ui.undoBtn.addEventListener('click', undo);
    ui.resetBtn.addEventListener('click', resetRecord);

    // 点空格滑动：事件代理到棋盘（车按钮自身有监听）
    ui.board.addEventListener('click', function (ev) {
      var cell = ev.target.closest ? ev.target.closest('.st-rh-cell') : null;
      if (!cell || !ui.board.contains(cell)) return;
      onCell(Number(cell.getAttribute('data-row')), Number(cell.getAttribute('data-col')));
    });

    newGame(LEVELS.map(function (l) { return l.mode; }).indexOf(S.mode));
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STRush = {
    slideRangeFor: slideRangeFor,
    allMovesFor: allMovesFor,
    applyMoveFor: applyMoveFor,
    solveFor: solveFor,
    cellsFor: cellsFor,
    levels: LEVELS,
    bestMove: function () { return bestMove(S.pos); },
    solve: function () { return solve(S.pos); },
    stepCount: function () { return stepCount(S.pos); },
    state: function () { return { pos: S.pos, sel: S.sel, mode: S.mode, steps: S.steps, ended: S.ended, cars: CARS }; }
  };
})(typeof window !== 'undefined' ? window : globalThis);
